export interface EnrichedUserDetailValueModel {
  id: string;
  enrichedUserDetailId: string;
  text: string;
  parentId: string;
  index: number;
}
